import type { Palette } from "@mui/material/styles/createPalette";
import type { TypographyVariantsOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    label: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    label?: React.CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    label: true;
  }
}

export const covestroMuiTypography:
  | TypographyVariantsOptions
  | ((palette: Palette) => TypographyVariantsOptions) = {
  label: {
    fontSize: "1em",
    fontWeight: 500,
  },
};
